// ChartLong.js
import dayjs from "dayjs";
import "./chart.css";
import React, { useEffect, useState } from "react";
import useInterval from "../layout/interval";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Surface,
  Symbols,
} from "recharts";

const tabs = [
  { label: "풍속(10m)", key: "풍속10m", content: "풍속(10m)(m/s)" },
  { label: "풍속(80m)", key: "풍속80m", content: "풍속(80m)(m/s)" },
  { label: "기온", key: "기온", content: "기온(°C)" },
];

export default function ChartLong({ chartDayLong }) {
  const [tabInfo, setTabInfo] = useState({
    label: "풍속(10m)",
    key: "풍속10m",
    content: "풍속(10m)(m/s)",
  });
  const [chartDayLongData, setChartDayLongData] = useState([]);

  const [currentBtn, setCurrentBtn] = useState("풍속(10m)");

  const handleClickTabInfo = (label) => {
    // console.log(label);
    const index = tabs.findIndex((info) => info.label === label);
    setTabInfo({ ...tabs[index] });
    setCurrentBtn(label);
  };

  const renderCustomizedLegend = ({ payload }) => {
    return (
      <div className="customized-legend">
        {payload.map((entry) => {
          const { dataKey, color, value } = entry;
          // console.log(entry);

          const style = {
            marginRight: 10,
            marginLeft: 10,
            color: "#6b6b6b",
            display:
              value === "최대발전량" || value === "최소발전량"
                ? "none"
                : "inline-block",
          };

          return (
            <span className="legend-item" key={dataKey} style={style}>
              <Surface width={10} height={10}>
                <Symbols cx={8} cy={8} type="square" size={80} fill={color} />
              </Surface>
              <span>{dataKey}</span>
            </span>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    if (Object.keys(chartDayLong).length > 0) {
      const tempDay = [];
      // 일자에 해당 하는 데이터들을 평균값 내서 새롭게 변수에다 넣는 코드
      Object.entries(chartDayLong).forEach(([date, data]) => {
        let windPowerAve = Math.floor(
          data.reduce((p, c) => p + c.평균발전량, 0) / data.length
        );
        let windPowerMin = Math.floor(
          data.reduce((p, c) => p + c.최소발전량, 0) / data.length
        );
        let windPowerMax = Math.floor(
          data.reduce((p, c) => p + c.최대발전량, 0) / data.length
        );
        let windSpeed80 =
          Math.floor(
            (data.reduce((p, c) => p + c.풍속80m, 0) / data.length) * 100
          ) / 100;
        let windSpeedLand = Math.floor(
          data.reduce((p, c) => p + c.풍속10m, 0) / data.length
        );
        let windTemp = Math.floor(
          data.reduce((p, c) => p + c.기온, 0) / data.length
        );

        const tempAvgData = {
          date: dayjs(date).format("MM/DD"),
          평균발전량: windPowerAve,
          최소발전량: windPowerMin,
          최대발전량: windPowerMax,
          풍속80m: windSpeed80,
          풍속10m: windSpeedLand,
          기온: windTemp,
        };
        tempDay.push(tempAvgData);
      });
      setChartDayLongData([...tempDay]);
      // console.log(tempDay); // 확인하고 지우기
    }
  }, [chartDayLong]);

  const [upDateTime, setupDateTime] = React.useState({
    업데이트시간: "",
  });
  React.useEffect(() => {
    fetch(
      "http://222.239.231.149:8080/dashboard/yeongam/data/updatetimeLong.json"
    )
      .then((res) => res.json())
      .then((data) => {
        setupDateTime(data);
      });
  }, []);

  useInterval(() => {
    fetch(
      "http://222.239.231.149:8080/dashboard/yeongam/data/updatetimeLong.json"
    )
      .then((res) => res.json())
      .then((data) => {
        setupDateTime(data);
      });
  }, 60000);

  return (
    <div className="chart">
      <div className="charttitle">
        <span className="chartname">기상&발전량 예측 정보(장기)</span>
        <span className="uptime">{upDateTime["업데이트시간"]}</span>
        <section
          style={{ position: "absolute", top: 0, right: 10, zIndex: 1000 }}
        >
          {tabs.map((info) => (
            <button
              className={
                "chartBtn" + (currentBtn === info.label ? " active" : "")
              }
              key={info.label}
              onClick={() => handleClickTabInfo(info.label)}
            >
              {info.label}
            </button>
          ))}
        </section>
      </div>
      <ResponsiveContainer>
        <ComposedChart
          className="text"
          data={chartDayLongData}
          margin={{
            top: 30,
            right: 20,
            bottom: 10,
            left: 20,
          }}
        >
          <CartesianGrid stroke="#d5d5d5" />
          <XAxis dataKey="date" stroke="#6b6b6b" strokeWidth={1} />
          <YAxis
            yAxisId="left"
            orientation="left"
            stroke="#6b6b6b"
            strokeWidth={2}
            label={{
              value: "발전량(MW)",
              offset: 15,
              angle: 0,
              position: "top",
            }}
          />
          <Tooltip position={{ y: 100 }} />
          <Legend
            verticalAlign="bottom"
            iconType="square"
            className="legend"
            content={renderCustomizedLegend}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke="#6b6b6b"
            strokeWidth={2}
            label={{
              value: tabInfo.content,
              offset: 15,
              angel: 0,
              position: "top",
            }}
          />
          <Area
            yAxisId="left"
            dataKey="최대발전량"
            stroke="#eaa621"
            fill="#eaa621"
            fillOpacity={1}
            type="monotone"
            dot={false}
            activeDot={false}
          />
          <Area
            yAxisId="left"
            dataKey="최소발전량"
            stroke="#eaa621"
            fill="#e9e9e9"
            fillOpacity={1}
            type="monotone"
            dot={false}
            activeDot={false}
          />
          <Bar
            fill="#328dac"
            className="barStyle"
            yAxisId="right"
            dataKey={tabInfo.key}
          />
          <Line
            yAxisId="left"
            dataKey="평균발전량"
            name="평균발전량"
            stroke="#e35642"
            strokeWidth={2}
            type="monotone"
            dot={false}
            activeDot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
